module.exports = __webpack_public_path__ + "static/assets/2d67c62dfbb06b80488b161610583f9c.eot";